export const imagesProfileData = require(`../assets/images/profile/profile_2.jpg`);
export const imagesGalleryData = [
  {
    id: 1,
    src: require(`../assets/images/gallery/gallery_1.jpg`),
    alt: "Image 1",
    description: {
      en: "Morning Coffee",
      id: "Kopi Pagi",
    },
  },
  {
    id: 2,
    src: require(`../assets/images/gallery/gallery_3.jpg`),
    alt: "Image 2",
    description: {
      en: "Workspace Setup",
      id: "Meja Kerja",
    },
  },
  {
    id: 3,
    src: require(`../assets/images/gallery/gallery_2.jpg`),
    alt: "Image 3",
    description: {
      en: "Tech Conference",
      id: "Konferensi Teknologi",
    },
  },
  {
    id: 4,
    src: require(`../assets/images/gallery/gallery_4.jpg`),
    alt: "Image 4",
    description: {
      en: "City Skyline",
      id: "Panorama Kota",
    },
  },
  {
    id: 5,
    src: require(`../assets/images/gallery/gallery_5.jpg`),
    alt: "Image 5",
    description: {
      en: "Team Meeting",
      id: "Rapat Tim",
    },
  },
  {
    id: 6,
    src: require(`../assets/images/gallery/gallery_6.jpg`),
    alt: "Image 6",
    description: {
      en: "Creative Studio",
      id: "Studio Kreatif",
    },
  },
];
export const portofolioData = [
  {
    id: 1,
    label: {
      en: "E-Commerce Platform",
      id: "Platform E-Commerce",
    },
    value: "01",
    alt: "e-commerce platform",
    src: require(`../assets/images/portofolio/portofolio_1.png`),
  },
  {
    id: 2,
    label: {
      en: "Portfolio Website",
      id: "Website Portofolio",
    },
    value: "02",
    alt: "portfolio website",
    src: require(`../assets/images/portofolio/portofolio_2.png`),
  },
  {
    id: 3,
    label: {
      en: "Mobile App UI/UX",
      id: "UI/UX Aplikasi Mobile",
    },
    value: "03",
    alt: "mobile app design",
    src: require(`../assets/images/portofolio/portofolio_3.png`),
  },
  {
    id: 4,
    label: {
      en: "Dashboard Analytics",
      id: "Dashboard Analitik",
    },
    value: "04",
    alt: "dashboard analytics",
    src: require(`../assets/images/portofolio/portofolio_4.png`),
  },
  {
    id: 5,
    label: null,
    value: null,
    src: "",
  },
  {
    id: 6,
    label: {
      en: "Social Media App",
      id: "Aplikasi Media Sosial",
    },
    value: "05",
    alt: "social media application",
    src: require(`../assets/images/portofolio/portofolio_5.png`),
  },
];
